import {
  Apartment,
  CreditCard,
  Dashboard,
  DirectionsBus,
  DirectionsCar,
  MonetizationOn,
  PanTool,
  Restore,
  StayCurrentPortrait,
  Visibility,
} from "@material-ui/icons";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AirportShuttleIcon from "@material-ui/icons/AirportShuttle";
import { find, findIndex } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../App";
import useWindowDimensions from "../../utils/dimension";

import {
  getPermission,
  getPermissionCode,
  redirect,
} from "../../utils/pagePermission";
import ResponsiveAppbar from "../ResponsiveAppbar";
import ResponsiveDrawer from "../ResponsiveDrawer";

const MenuBarLayout = (props) => {
  const { t, i18n } = useTranslation();
  const { height } = useWindowDimensions();
  const { children, match, location } = props;
  const [showSideBar, setShowSideBar] = useState(false);
  const { state } = useContext(AuthContext);

  const permissionGranted = (code) => {
    let permissions = [];
    if (state.permissions.length > 0) {
      permissions = state.permissions;
    } else if (localStorage.getItem("permissions")) {
      permissions = localStorage
        .getItem("permissions")
        .split(",")
        .map((ele) => parseInt(ele));
    }
    return permissions.includes(code);
  };

  const [filterList, setFilterList] = useState([]);

  const [lists, setLists] = useState([
    {
      whiteIcon: <Visibility style={{ color: "#fff" }} />,
      blackIcon: <Visibility style={{ color: "#333" }} />,
      selectedIcon: <Visibility style={{ color: "#0052cc" }} />,
      text: "實時監測",
      link: `/`,
      name: "court-home",
      isActive: false,
      children: [],
    },
    {
      whiteIcon: <AirportShuttleIcon style={{ color: "#fff" }} />,
      blackIcon: <AirportShuttleIcon style={{ color: "#333" }} />,
      selectedIcon: <AirportShuttleIcon style={{ color: "#0052cc" }} />,
      text: "到站時間表",
      link: `/arrival-timetable`,
      name: "arrival-timetable",
      isActive: false,
      children: [],
    },
    {
      whiteIcon: <Restore style={{ color: "#fff" }} />,
      blackIcon: <Restore style={{ color: "#333" }} />,
      selectedIcon: <Restore style={{ color: "#0052cc" }} />,
      text: "行車紀錄",
      // link: `/trips`,
      name: "trip-viewer",
      isActive: false,
      isExpand: true,
      children: [
        {
          text: "行車軌跡",
          link: `/trip-replay`,
          name: "trip-replay",
          isActive: false,
        },
        {
          text: "行程追溯",
          link: `/trips`,
          name: "trip-viewer",
          isActive: false,
        },
        {
          text: "過去數據",
          link: `/s3-archive`,
          name: "s3-archive",
          isActive: false,
        },
      ],
    },
    {
      whiteIcon: <AssessmentIcon style={{ color: "#fff" }} />,
      blackIcon: <AssessmentIcon style={{ color: "#333" }} />,
      selectedIcon: <AssessmentIcon style={{ color: "#0052cc" }} />,
      text: "營運報表",
      name: "operating-report",
      isActive: false,
      isExpand: true,
      children: [
        {
          text: "營運總覽",
          link: `/operation-summary-report`,
          name: "operation-summary-report",
          isActive: false,
        },
        {
          text: "里數報表",
          link: `/miles-report`,
          name: "miles-report",
          isActive: false,
        },
        // {
        //   text: "每日營運報表",
        //   link: `/daily-operation-report`,
        //   name: "daily-operation-report",
        //   isActive: false,
        // },
        // {
        //   text: "每日營運報表 (營運商)",
        //   link: `/daily-operation-report-operator-view`,
        //   name: "daily-operation-report-operator-view",
        //   isActive: false,
        // },
        {
          text: "車輛編配報表",
          link: `/vehicle-allocation-report`,
          name: "vehicle-allocation-report",
          isActive: false,
        },
        {
          text: "行車時間報表",
          link: `/journey-time-report`,
          name: "journey-time-report",
          isActive: false,
        },
        {
          text: "班次報表",
          link: `/departure-arrival-report`,
          name: "departure-arrival-report",
          isActive: false,
        },
        // {
        //   text: "總站班次報表 (小時摘要)",
        //   link: `/terminus-report-hourly`,
        //   name: "terminus-report-hourly",
        //   isActive: false,
        // },
        // {
        //   text: "總站班次報表 (所有班次摘要)",
        //   link: `/terminus-report-every`,
        //   name: "terminus-report-every",
        //   isActive: false,
        // },
        // {
        //   text: "總站班次報表 (全日、特定時間摘要)",
        //   link: `/terminus-report-full`,
        //   name: "terminus-report-full",
        //   isActive: false,
        // },
        // {
        //   text: "中途站班次報表 (小時摘要)",
        //   link: `/enroute-report-hourly`,
        //   name: "enroute-report-hourly",
        //   isActive: false,
        // },
        // {
        //   text: "中途站班次報表 (所有班次摘要)",
        //   link: `/enroute-report-every`,
        //   name: "enroute-report-every",
        //   isActive: false,
        // },
        // {
        //   text: "中途站班次報表 (全日、特定時間摘要)",
        //   link: `/enroute-report-full`,
        //   name: "enroute-report-full",
        //   isActive: false,
        // },
      ],
    },
    {
      whiteIcon: <AssessmentIcon style={{ color: "#fff" }} />,
      blackIcon: <AssessmentIcon style={{ color: "#333" }} />,
      selectedIcon: <AssessmentIcon style={{ color: "#0052cc" }} />,
      text: "服務異常報表",
      name: "exception-summary-report",
      isActive: false,
      isExpand: true,
      children: [
        {
          text: "服務異常總覽",
          link: `/exception-summary-report`,
          name: "exception-summary-report",
          isActive: false,
        },
        {
          text: "偏離路線報表",
          link: `/out-of-route-report`,
          name: "out-of-route-report",
          isActive: false,
        },
        {
          text: "行車時間異常報表",
          link: `/journey-time-exception-report`,
          name: "journey-time-report",
          isActive: false,
        },
        {
          text: "全車隊未能接收數據報表",
          link: `/ffnd-report`,
          name: "ffnd-report",
          isActive: false,
        },
        {
          text: "同一位置報表",
          link: `/rsl-report`,
          name: "rsl-report",
          isActive: false,
        },
        {
          text: "超速報表 (只供參考)",
          link: `/speeding-report`,
          name: "speeding-report",
          isActive: false,
        },
        {
          text: "營運時間異常報表",
          link: `/oor-hour-report`,
          name: "oor-hour-report",
          isActive: false,
        },
        {
          text: "營運日子異常報表",
          link: `/oor-day-report`,
          name: "oor-day-report",
          isActive: false,
        },
      ],
    },
    {
      whiteIcon: <AssessmentIcon style={{ color: "#fff" }} />,
      blackIcon: <AssessmentIcon style={{ color: "#333" }} />,
      selectedIcon: <AssessmentIcon style={{ color: "#0052cc" }} />,
      text: "系統異常報表",
      name: "system-exception-report",
      isActive: false,
      isExpand: true,
      children: [
        {
          text: "離線報表",
          link: `/offline-report`,
          name: "offline-report",
          isActive: false,
        },
        // {
        //   text: "錯誤報表",
        //   link: `/error-report`,
        //   name: "error-report",
        //   isActive: false,
        // },
      ],
    },
    {
      whiteIcon: <Dashboard style={{ color: "#fff" }} />,
      blackIcon: <Dashboard style={{ color: "#333" }} />,
      selectedIcon: <Dashboard style={{ color: "#0052cc" }} />,
      text: "管理",
      name: "management",
      isActive: false,
      isExpand: true,
      children: [
        {
          text: "電子圍欄",
          link: `/geo-fencing`,
          name: "geo-fencing",
          isActive: false,
        },
        {
          text: "新增路線",
          link: `/add-route`,
          name: "add-route",
          isActive: false,
        },
        {
          text: "路線設定",
          link: `/route-management`,
          name: "route-management",
          isActive: false,
        },
        {
          text: "營運商設定",
          link: `/operator-config`,
          name: "operator-config",
          isActive: false,
        },
        {
          text: "裝置設定",
          link: `/device-config`,
          name: "device-config",
          isActive: false,
        },
        {
          text: "小巴設定",
          link: `/gmb-config`,
          name: "gmb-config",
          isActive: false,
        },
        {
          text: "用戶設定",
          link: `/user-config`,
          name: "user-config",
          isActive: false,
        },
        {
          text: "班次設定",
          link: `/schedule-config`,
          name: "schedule-config",
          isActive: false,
        },
        {
          text: "臨時停用到站預報",
          link: `/temp-disable-eta`,
          name: "temp-disable-eta",
          isActive: false,
        },
        {
          text: "臨時停用到站預報（個別路線/車站）",
          link: `/temp-disable-eta-individual`,
          name: "temp-disable-eta-individual",
          isActive: false,
        },
      ],
    },
    {
      whiteIcon: <ExitToAppIcon style={{ color: "#fff" }} />,
      blackIcon: <ExitToAppIcon style={{ color: "#333" }} />,
      selectedIcon: <ExitToAppIcon style={{ color: "#0052cc" }} />,
      text: "登出",
      link: `/logout`,
      name: "logout",
      isActive: false,
      children: [],
    },
  ]);

  const initActiveState = (tempLists) => {
    return tempLists.map((list) => {
      list.isActive = false;
      list.children = list.children.map((child) => {
        child.isActive = false;
        return child;
      });
      return list;
    });
  };

  const getActiveIndices = (list, parentText, childText, shouldGetChild) => {
    const index = findIndex(list, { text: parentText });
    if (shouldGetChild) {
      const subIndex = findIndex(list[index].children, {
        text: childText,
      });
      return [index, subIndex];
    }
    return index;
  };

  const markActiveListItem = (tempFilterList) => {
    let tempLists = tempFilterList;
    tempLists = initActiveState(tempLists);
    let index = null;
    let subIndex = null;
    // Report Related
    // if (location.pathname.includes("/trip-detail")) {
    //   const index = findIndex(lists, { text: "小巴報表" });
    //   tempLists[index].isActive = true;
    //   const subIndex = findIndex(tempLists[index].children, {
    //     text: "完整報表",
    //   });
    //   tempLists[index].children[subIndex].isActive = true;
    // } else
    if (location.pathname.includes("/trip-replay")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "行車紀錄",
        "行車軌跡",
        true
      );
    } else if (location.pathname.includes("/trips")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "行車紀錄",
        "行程追溯",
        true
      );
    } else if (location.pathname.includes("/arrival-timetable")) {
      index = getActiveIndices(tempLists, "到站時間表", null, false);
    } else if (location.pathname.includes("/operation-summary-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "營運報表",
        "營運總覽",
        true
      );
    } else if (location.pathname.includes("/miles-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "營運報表",
        "里數報表",
        true
      );
    } else if (location.pathname.includes("/offline-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "系統異常報表",
        "離線報表",
        true
      );
      // } else if (location.pathname.includes("/error-report")) {
      //   [index, subIndex] = getActiveIndices(
      //     tempLists,
      //     "系統異常報表",
      //     "錯誤報表",
      //     true
      //   );
      // } else if (
      //   location.pathname.includes("/daily-operation-report-operator-view")
      // ) {
      //   [index, subIndex] = getActiveIndices(
      //     tempLists,
      //     "營運報表",
      //     "每日營運報表 (營運商)",
      //     true
      //   );
      //   console.log("==== index", index);
      // } else if (location.pathname.includes("/daily-operation-report")) {
      //   [index, subIndex] = getActiveIndices(
      //     tempLists,
      //     "營運報表",
      //     "每日營運報表",
      //     true
      //   );
    } else if (location.pathname.includes("/vehicle-allocation-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "營運報表",
        "車輛編配報表",
        true
      );
    } else if (location.pathname.includes("/journey-time-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "營運報表",
        "行車時間報表",
        true
      );
    } else if (location.pathname.includes("/departure-arrival-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "營運報表",
        "班次報表",
        true
      );
    } else if (location.pathname.includes("/out-of-route-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "偏離路線報表",
        true
      );
    } else if (location.pathname.includes("/journey-time-exception-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "行車時間異常報表",
        true
      );
    } else if (location.pathname.includes("/ffnd-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "全車隊未能接收數據報表",
        true
      );
    } else if (location.pathname.includes("/rsl-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "同一位置報表",
        true
      );
    } else if (location.pathname.includes("/speeding-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "超速報表 (只供參考)",
        true
      );
    } else if (location.pathname.includes("/exception-summary-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "服務異常總覽",
        true
      );
    } else if (location.pathname.includes("/oor-hour-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "營運時間異常報表",
        true
      );
    } else if (location.pathname.includes("/oor-day-report")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "服務異常報表",
        "營運日子異常報表",
        true
      );
    }

    // Notification Related
    else if (location.pathname.includes("/notification")) {
      index = getActiveIndices(tempLists, "自動化提示", null, false);
    }

    // Management Related
    else if (location.pathname.includes("/route-management")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "路線設定", true);
    }
    // else if (location.pathname.includes("/gmb-schedule")) {
    //   [index, subIndex] = getActiveIndices(tempLists, "管理", "時間表", true);
    // }
    else if (location.pathname.includes("/geo-fencing")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "電子圍欄", true);
    }
    // else if (location.pathname.includes("/vehicle-schedule")) {
    //   [index, subIndex] = getActiveIndices(
    //     tempLists,
    //     "管理",
    //     "車輛時間表",
    //     true
    //   );
    // }
    else if (location.pathname.includes("/web-app-config")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "管理",
        "應用程式設定",
        true
      );
    } else if (location.pathname.includes("/device-config")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "裝置設定", true);
    } else if (location.pathname.includes("/operator-config")) {
      [index, subIndex] = getActiveIndices(
        tempLists,
        "管理",
        "營運商設定",
        true
      );
    } else if (location.pathname.includes("/gmb-config")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "小巴設定", true);
    } else if (location.pathname.includes("/add-route")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "新增路線", true);
    } else if (location.pathname.includes("/user-config")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "用戶設定", true);
    } else if (location.pathname.includes("/schedule-config")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "班次設定", true);
    } else if (location.pathname.includes("/temp-disable-eta-individual")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "臨時停用到站預報（個別路線/車站）", true);
    } else if (location.pathname.includes("/temp-disable-eta")) {
      [index, subIndex] = getActiveIndices(tempLists, "管理", "臨時停用到站預報", true);
    }

    // Vehicle Related
    // else if (location.pathname.includes("/vehicle-management")) {
    //   index = getActiveIndices(tempLists,"車輛", null, false);
    // }

    // Device Related
    // else if (location.pathname.includes("/device-status")) {
    //   index = getActiveIndices(tempLists, "裝置狀態", null, false);
    // }

    // Default
    else {
      index = getActiveIndices(tempLists, "實時監測", null, false);
    }

    if (typeof index === "number") {
      tempLists[index].isActive = true;
      if (typeof subIndex === "number") {
        tempLists[index].children[subIndex].isActive = true;
      }
    }

    return tempLists;
  };

  const triggerRedirect = (link, name) => {
    const permissions = getPermission(state);
    redirect(props.history, link, name, permissions);
  };

  useEffect(() => {
    if (lists?.length > 0 && filterList.length === 0) {
      const tempFilterList = lists
        .map((ele) => {
          if (permissionGranted(getPermissionCode(ele.name))) {
            ele.children = ele.children.filter((child) =>
              permissionGranted(getPermissionCode(child.name))
            );
            return ele;
          }
          return null;
        })
        .filter((ele) => !!ele);
      setFilterList(markActiveListItem(tempFilterList));
    }
  }, [lists, location]);

  useEffect(() => {
    if (filterList.length > 0) {
      setFilterList(markActiveListItem(filterList));
    }
  }, [location]);

  const logoutButton = find(lists, { name: "logout" });
  const NormalBar = () => {
    return (
      <>
        <ResponsiveAppbar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          // lists={filterList}
          logout={[logoutButton]}
          // lists={lists}
          setLists={setFilterList}
          redirect={triggerRedirect}
        />
        <ResponsiveDrawer
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          lists={filterList}
          logout={[logoutButton]}
          // lists={lists}
          setLists={setFilterList}
          redirect={triggerRedirect}
        />
      </>
    );
  };

  return (
    <>
      {/* {isTd && <TdBar />}
      {isHp && <HpBar />}
      {!isTd && !isHp && <NormalBar />} */}
      <NormalBar />
      <div
        style={{
          height: `calc(${height}px - 64px)`,
          marginTop: "64px",
          width: "100vw",
        }}
      >
        {children}
      </div>
    </>
  );
};

export default withRouter(MenuBarLayout);
